import { useEffect } from 'react';
import { SongList } from 'app/components/Song';
import { useAppDispatch, useAppSelector } from 'app/store';
import { resetSongCountAction } from 'app/store/SongList/slice';
import { getFolder } from 'app/store/SongList/selectors';
import { useParams, useNavigate } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { SongFolderHeader } from './SongFolderHeader';

export const SongFolder = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { guid } = useParams();
  const folder = useAppSelector(getFolder(guid || ''));

  useEffect(
    () => () => {
      dispatch(resetSongCountAction());
    },
    [dispatch]
  );

  if (!folder) {
    navigate(routes.songs.path, { replace: true });
  }

  return (
    <>
      {folder && <SongFolderHeader folder={folder} />}
      <ContentContainer
        type={ContentContainerType.LIST}
        isViewContent
        sx={{ pt: 0, px: 4 }}
      >
        <SongList folder={folder} />
      </ContentContainer>
    </>
  );
};
